import React, { useState, useEffect } from "react";
import Api from "../../components/api/Api";
import { Col, Container, Row } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../components/common/spinner/Spinner";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";

const EditPartnerCategory = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [initialValues, setInitialValues] = useState(null);

  const getCategoryApi = Api({
    url: `admin/associate/partner/category/${id}`,
  });

  const updateCategoryApi = Api({
    url: `admin/associate/partner/category/edit`,
  });

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await getCategoryApi.fetchDataBySingleId();
        if (response && response.data && response.data.statusType === "SUCCESS") {
          const cat = response.data.associatePartnerCategory;
          setInitialValues({
            name: cat.name || "",
            description: cat.description || "",
          });
        } else {
          showToast("Failed to fetch category details", { type: "error" });
        }
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    };
    if (id) {
      fetchCategory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true);

      const data = {
        id: Number(id),
        name: values.name,
        description: values.description,
      };

      const response = await updateCategoryApi.editData(data);
      if (response && response.data && response.data.statusType === "SUCCESS") {
        showToast("Partner Category updated successfully", {
          type: "success",
        });

        setTimeout(() => {
          navigate("/partner-categories");
        }, 3000);
      } else {
        showToast("Failed to update partner category", {
          type: "error",
        });
      }
    } catch (error) {
      console.error(error);
      showToast("Error Occurred or Endpoint Not Provided", {
        type: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Partners", link: "/partners" },
    { label: "Partner Categories", link: "/partner-categories" },
    { label: "Edit Partner Category", link: "", active: true },
  ];

  return (
    <>
      <Notification />
      <Container fluid style={{ marginTop: "2rem", padding: "0rem 4rem" }}>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={12} md={12} sm={12}>
            <SingleDetailHeader
              header="Edit Partner Category"
              description={`Update details for category ID: ${id}`}
            />
            {initialValues ? (
              <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">
                        Name
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="Enter category name"
                        name="name"
                        required
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="description" className="form-label">
                        Description
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        id="description"
                        placeholder="Enter description"
                        name="description"
                        required
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary mt-4"
                      style={{ marginBottom: "10rem" }}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <Spinner loading={true} />
                      ) : (
                        "Update Category"
                      )}
                    </button>
                  </Form>
                )}
              </Formik>
            ) : (
              <div className="text-center my-5">
                <Spinner loading={true} />
                <p className="mt-3">Loading category details...</p>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditPartnerCategory;
